import React, { useState } from 'react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/shadcn/tooltip';
import { copyTextToClipboard } from '@/utils/url';
import CheckIcon from '@/components/ui/icons/CheckIcon';
import CopyIcon from '@/components/ui/icons/ClipboardCopy';
import { cn } from '@/utils/styles';

interface Props {
  content: string;
  iconClassName?: string;
}

export default function CopyToClipboard({ content, iconClassName }: Props) {
  const [success, setSuccess] = useState(false);

  const handleCopy = () => {
    copyTextToClipboard(content);
    setSuccess(true);

    setTimeout(() => {
      setSuccess(false);
    }, 1000);
  };

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild onClick={handleCopy} className="cursor-pointer">
          {success ? (
            <CheckIcon className={cn('mr-1 size-4', iconClassName)} />
          ) : (
            <CopyIcon className={cn('mr-1 size-4', iconClassName)} />
          )}
        </TooltipTrigger>
        <TooltipContent className="cursor-pointer" onClick={handleCopy}>
          {content}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
